import { render, staticRenderFns } from "./DataReportOweDetailStatistics.vue?vue&type=template&id=f2e089ca&scoped=true"
import script from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportOweDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportOweDetailStatistics.vue?vue&type=style&index=0&id=f2e089ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e089ca",
  null
  
)

export default component.exports